export default {
  filesCount: 'Počet souborů:',
  filesAction: 'Pro dokončení nahrávání {{count}} vybraných souborů klikněte na uložit otázku níže.',
  filesAction_one: 'Pro dokončení nahrávání {{count}} vybraného souboru klikněte na uložit otázku níže.',
};
